<template>
    <v-container>
        <div v-if="dialog">
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline"
                        >Verificación de validez</v-card-title
                    >
                    <v-card-text>
                        <v-col>
                            Para corroborar la legitimidad del documento por
                            favor ingresa el código que se encuentra en el pie
                            de página del mismo.
                        </v-col>
                        <v-col>
                            <v-form v-model="isValid">
                                <v-text-field
                                    :loading="loading"
                                    :rules="[
                                        (v) => !!v || 'El código es requerido',
                                    ]"
                                    required
                                    outlined
                                    label="Código del documento"
                                    v-model="code"
                                ></v-text-field>
                            </v-form>
                        </v-col>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                :disabled="!isValid"
                                color="primary"
                                @click="verificate"
                                >Verificar</v-btn
                            >
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <div v-else-if="!dialog">
            <v-card style="background: #919191; width:100%">
                <div class="container">
                    <v-card :loading="loading" class="template">
                        <div id="content" style="padding-bottom: 0">
                            <p v-if="company.companyLogoSignedUrl">
                                <img :src="company.companyLogoSignedUrl" />
                            </p>
                            <br /><br /><br />
                            <p>
                                Bogotá,
                                <span style="font-weight: bolder;">{{
                                    $moment().format("D MMMM YYYY")
                                }}</span
                                >,
                            </p>
                            <br /><br /><br /><br />
                            <p>
                                <span style="font-weight: bolder;"
                                    >{{ company.companyName }} CERTIFICA
                                    QUE:</span
                                >
                            </p>
                            <p v-if="!agreement.agreementDateEnd">
                                <span style="font-weight: bolder;"
                                    >{{ person.personFullName }} </span
                                >identificado con el documento
                                <span style="font-weight: bolder;"
                                    >{{ person.identificationTypeName }}
                                    {{
                                        person.personNumberIdentification
                                    }},</span
                                >
                                labora en nuestra compañía con
                                <span style="font-weight: bolder;">{{
                                    agreement.agreementKindName
                                }}</span>
                                desde
                                <span style="font-weight: bolder;">{{
                                    $moment(
                                        agreement.agreementDateStart
                                    ).format("D/M/YYYY")
                                }}</span>
                                en el cargo de
                                <span style="font-weight: bolder;">{{
                                    agreement.jobTitleName
                                }}</span>
                                con un salario promedio mensual de
                                <span style="font-weight: bolder;">{{
                                    salary.agreementSalaryValue
                                        | formatToCurrency
                                }}</span
                                >.
                            </p>
                            <p v-else-if="agreement.agreementDateEnd">
                                <span style="font-weight: bolder;"
                                    >{{ person.personFullName }} </span
                                >identificado con el documento
                                <span style="font-weight: bolder;">
                                    {{ person.identificationTypeName }}
                                    {{
                                        person.personNumberIdentification
                                    }},</span
                                >
                                laboró en nuestra compañía con
                                <span style="font-weight: bolder;">{{
                                    agreement.agreementKindName
                                }}</span>
                                desde
                                <span style="font-weight: bolder;">{{
                                    $moment(
                                        agreement.agreementDateStart
                                    ).format("D/M/YYYY")
                                }}</span>
                                hasta
                                <span style="font-weight: bolder;">
                                    {{
                                        $moment(
                                            agreement.agreementDateEnd
                                        ).format("D/M/YYYY")
                                    }}
                                </span>
                                en el cargo de
                                <span style="font-weight: bolder;">{{
                                    agreement.jobTitleName
                                }}</span>
                                con un salario promedio mensual de
                                <span style="font-weight: bolder;">{{
                                    salary.agreementSalaryValue
                                        | formatToCurrency
                                }}</span
                                >.
                            </p>
                            <br /><br /><br /><br />
                            <p>
                                La presente certificación se expide a petición
                                del interesado en la ciudad de Bogotá a la fecha
                                <span style="font-weight: bolder;">{{
                                    $moment().format("D MMMM YYYY")
                                }}</span>
                            </p>
                            <br /><br /><br /><br />
                            <p>
                                <span style="font-weight: bolder;"
                                    >__________________________________________</span
                                >
                            </p>
                            <p>
                                <span style="font-weight: bolder;">
                                    COORDINADOR DE RECURSOS HUMANOS</span
                                >
                            </p>
                            <br /><br /><br /><br /><br />
                            <p style="text-align: right;">
                                <span style="font-weight: bolder;">{{
                                    company.companyAddress
                                }}</span>
                            </p>
                            <p style="text-align: right;">
                                <span style="font-weight: bolder;"
                                    >PBX: {{ company.companyPhone }}&nbsp;</span
                                >
                            </p>
                            <p style="text-align: right;">
                                <span style="font-weight: bolder;"
                                    >Bogotá-Colombia</span
                                >
                            </p>
                            <br /><br />
                        </div>
                    </v-card>
                </div>
            </v-card>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
// import { getToken } from "@/assets/js/shared/utils.js";
import { responseException } from "@/assets/js/common";

export default {
    name: "ValidateCertification",
    data() {
        return {
            overlay: false,
            isValid: true,
            dialog: true,
            loading: false,
            code: "",
            company: {},
            person: {},
            agreement: {},
            salary: {},
        };
    },
    methods: {
        verificate() {
            this.loading = true;
            this.overlay = true;
            let consecutive = this.code.slice(5);

            if (!this.person) return

            this.$http
                .get(`common/anonymous/agreement?portalName=${this.$route.params.company}&consecutive=${consecutive}`)
                .then((response) => {
                    this.getCompany();

                    // console.log("agreement >>> ", response.body);
                    let agreement = response.body;

                    if (agreement) {
                        if (
                            agreement.agreementConsecutive.toString() ===
                            consecutive.toString().replace(/^0+/, "")
                        ) {
                            this.$swal({
                                icon: 'success',
                                title: this.$t('processSuccess'),
                                text: this.$t('documentIsValid'),
                                confirmButtonColor: '#8bc34a'
                            })
                            this.getSalary(agreement.id);
                            this.dialog = false;
                        } else {
                            this.$swal({
                                icon: 'error',
                                title: this.$t('errorOcurred'),
                                text: this.$t('incorrectCode')
                            })
                        }

                        this.loading = false;
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: this.$t('errorOcurred'),
                            text: responseException(response)
                        })
                        this.loading = false;
                    }
                }).catch((response) => {
                    this.loading = false;

                    this.$swal({
                        icon: 'error',
                        title: this.$t('errorOcurred'),
                        text: responseException(response)
                    })
                }).then(() => setTimeout(() => {
                    this.overlay = false;
                }, 3000));
        },
        getCompany() {
            return this.$http
                .get(`common/anonymous/company?portalName=${this.$route.params.company}`)
                .then((response) => {
                    this.company = response.body;
                    return this.$http.get("common/attachments/signed", { params: { redirect: false, url: this.company.companyLogo } })
                }).then(({ data }) => {
                    this.company.companyLogoSignedUrl = data
                    return this.getPersons();
                }).catch((error) => {
                    console.error(error);

                    this.$swal({
                        icon: 'error',
                        title: this.$t('errorOcurred'),
                        text: responseException(error)
                    })
                });
        },
        getPersons() {
            return this.$http
                .get(`common/anonymous/persons?portalName=${this.$route.params.company}`)
                .then((response) => {
                    let persons = response.body;

                    persons.data.forEach((p) => {
                        p.personId.slice(9, 13) === this.code.slice(0, 4)
                            ? (this.person = p)
                            : false;
                    });

                    // console.log("persons >>> ", response.body);
                    // console.log("person >>> ", this.person);
                    // this.getAgreement();
                }).catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: this.$t('errorOcurred'),
                        text: responseException(error)
                    })

                    console.error(error);
                });
        },
        getSalary(id) {
            return this.$http
                .get(`common/anonymous/agreement/${id}/salaries?portalName=${this.$route.params.company}`)
                .then((response) => {
                    this.salary = response.body[0];
                    // console.log("salary > ", response.body);
                }).catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: this.$t('errorOcurred'),
                        text: responseException(error)
                    })
                });
        },
    },
};
</script>
